import axios from 'axios'
import { getToken, removeLogin } from '@/utils/auth'

let SERVER_URL = process.env.VUE_APP_SERVER_URL
/**
 * 请求字符串处理：json=> urlStr
 * @param obj
 * @return {string}
 */
const toQueryString = function (obj) {
  return obj ? Object.keys(obj).sort().map(function (key) {
    const val = obj[key]
    if (Array.isArray(val)) {
      return val.sort().map(function (val2) {
        return encodeURIComponent(key) + '=' + encodeURIComponent(val2)
      }).join('&')
    }
    return encodeURIComponent(key) + '=' + encodeURIComponent(val)
  }).join('&') : ''
}

// create an axios instance
const service = axios.create({
  headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  withCredentials: true,
  timeout: 50000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    if (process.env.NODE_ENV === 'production') {
      config.baseURL = SERVER_URL
    }
    let sendData = config.data
    if (config.method === 'get') {
      sendData = config.params
    }
    if (!sendData) {
      sendData = {}
    }
    let token = getToken()
    if (token) {
      if (config.headers['Content-Type'] === 'multipart/form-data') {
        config.url = config.url + '?token=' + token
      } else if (!sendData['token']) {
        // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
        sendData['token'] = token
      }
    }
    if (config.method === 'get') {
      config.params = sendData
    } else if (config.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
      config.data = toQueryString(sendData)
    }
    return config
  },
  error => {
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  // response => response,
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过 xmlhttprequest 来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  response => {
    let errorJson = response.headers['error-json']
    if (errorJson) {
      errorJson = JSON.parse(errorJson)
      if (errorJson.code == '131000') {
        // TODO:登录回话超时
        removeLogin();
        location.reload()
      }
      return response.data
    }
    // 正常返回了数据
    return response.data
  },
  error => {
    console.log('err' + error) // for debug
    return Promise.reject(error)
  }
)

export default service
